import { Layout } from 'antd';
import styled from 'styled-components';

export const DashboardContent = styled(Layout.Content)<{ isExtraSmallScreen?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;

  .dashboard-content {
    padding: ${({ isExtraSmallScreen }) => (isExtraSmallScreen ? '0 16px 16px 16px' : '0 40px 40px 40px')};
  }
`;
